<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.858 2.28564H1.14369C0.828103 2.28564 0.572266 2.54148 0.572266 2.85707V11.9999C0.572266 12.3155 0.828103 12.5714 1.14369 12.5714H14.858C15.1735 12.5714 15.4294 12.3155 15.4294 11.9999V2.85707C15.4294 2.54148 15.1735 2.28564 14.858 2.28564Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.8577 12.5713L5.71484 15.4284"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.14453 12.5713L10.2874 15.4284"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.57227 15.4287H11.4294"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
